import { render, staticRenderFns } from "./BowReviewsBlock.vue?vue&type=template&id=69bf1c90&"
import script from "./BowReviewsBlock.vue?vue&type=script&lang=js&"
export * from "./BowReviewsBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BowHeading: require('/workspace/components/atoms/BowHeading/BowHeading.vue').default,BowWrapper: require('/workspace/components/base/BowWrapper/BowWrapper.vue').default,BowReviews: require('/workspace/components/molecules/BowReviews/BowReviews.vue').default})
